import React, { useState } from 'react';
import { FaQuestionCircle, FaPhoneAlt, FaEnvelope, FaChevronDown, FaChevronUp, FaSearch, FaTicketAlt, FaComments, FaBook,FaGlobe, FaUser, FaGem, FaLock } from 'react-icons/fa';
import { motion } from 'framer-motion';
import CustomDropdown from '../common/UserCustomDropdown';

const Help = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [openIndex, setOpenIndex] = useState(null);
    const [activeCategory, setActiveCategory] = useState('all');
    const [contactForm, setContactForm] = useState({
        subject: '',
        message: ''
    });

    // CustomDropdown options for subject
    const subjectOptions = [
        { value: 'general', label: 'General Inquiry' },
        { value: 'technical', label: 'Technical Issue' },
        { value: 'billing', label: 'Billing Issue' },
        { value: 'report', label: 'Report a Profile' },
        { value: 'account', label: 'Account Issue' },
        { value: 'membership', label: 'Membership Issue' }
    ];

    const categories = [
    { id: 'all', label: 'All Topics', icon: <FaGlobe /> },
    { id: 'account', label: 'Account & Profile', icon: <FaUser /> },
    { id: 'membership', label: 'Membership & Payments', icon: <FaGem /> },
    { id: 'privacy', label: 'Privacy & Safety', icon: <FaLock /> },
    { id: 'matches', label: 'Matches & Chat', icon: <FaComments /> }
];

    const faqs = [
        { category: 'account', q: "How do I edit my profile?", a: "Go to the 'Profile' tab in the dashboard and click on the 'Edit Profile' button. You can update all your details there." },
        { category: 'matches', q: "How can I contact a match?", a: "You can click on the 'Connect' button on any profile. If you are a premium member, you can also view their contact number." },
        { category: 'privacy', q: "Is my data safe?", a: "Yes, we use bank-grade encryption to protect your data. You can control your privacy settings in the 'Settings' tab." },
        { category: 'membership', q: "How do I upgrade my membership?", a: "Visit the 'Membership Plans' section to view and purchase premium plans." },
        { category: 'account', q: "How do I change my password?", a: "Go to Settings > Account > Change Password to update your login credentials." },
        { category: 'membership', q: "What is the refund policy?", a: "We offer a 7-day money-back guarantee if you are not satisfied with our premium services." },
        { category: 'privacy', q: "Can I hide my profile from specific users?", a: "Yes, you can use the 'Block' feature to prevent specific users from viewing your profile." },
        { category: 'matches', q: "How does the matching algorithm work?", a: "Our algorithm considers your preferences, interests, and compatibility factors to suggest the most suitable matches." }
    ];

    const filteredFaqs = faqs.filter(faq =>
        (activeCategory === 'all' || faq.category === activeCategory) &&
        (faq.q.toLowerCase().includes(searchQuery.toLowerCase()) || faq.a.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    const handleContactSubmit = (e) => {
        e.preventDefault();
        console.log("Contact form submitted:", contactForm);
        // Add your form submission logic here
        setContactForm({ subject: '', message: '' });
    };

    return (
        <div className="min-h-full bg-transparent p-4 lg:p-8">
            <div className="w-full mx-auto">
                {/* Hero Search Section */}
                <div className=" p-8 lg:p-12 text-center text-white mb-12 relative overflow-hidden">
                    <div className="absolute inset-0"></div>
                    <div className="relative z-10">
                        <h2 className="text-3xl lg:text-4xl font-bold mb-6 text-primary-pink">How can we help you today?</h2>
                        <div className="max-w-2xl mx-auto relative">
                            <div className="relative">
                                <FaSearch className="absolute left-5 top-1/2 -translate-y-1/2 text-text-muted text-lg z-10" />
                                <input
                                    type="text"
                                    placeholder="Search for answers, guides, or topics..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="w-full pl-14 pr-6 py-4 rounded-2xl text-text-primary focus:outline-none focus:ring-2 focus:ring-rose-300/50 shadow-xl backdrop-blur-sm bg-glass-card backdrop-blur-md border border-glass-border shadow-glass"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Quick Actions */}
                {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                    <motion.div 
                        whileHover={{ y: -5 }}
                        className="bg-gradient-to-br from-white to-blue-50 p-8 rounded-3xl shadow-lg border border-glass-border hover:shadow-xl transition-all duration-300 text-center group"
                    >
                        <div className="w-16 h-16 bg-gradient-to-br from-[rgba(255,255,255,0.1)] to-[rgba(255,255,255,0.05)] rounded-full flex items-center justify-center text-primary-pink mx-auto mb-5 text-2xl group-hover:scale-110 transition-transform duration-300">
                            <FaBook />
                        </div>
                        <h3 className="font-bold text-text-primary text-lg mb-3">Guides & Tutorials</h3>
                        <p className="text-sm text-text-muted leading-relaxed">Learn how to use our platform effectively with step-by-step guides.</p>
                        <button className="mt-4 text-primary-pink text-sm font-semibold hover:text-blue-700 transition-colors">
                            Browse Guides →
                        </button>
                    </motion.div>
                    
                    <motion.div 
                        whileHover={{ y: -5 }}
                        className="bg-gradient-to-br from-white to-green-50 p-8 rounded-3xl shadow-lg border border-green-100 hover:shadow-xl transition-all duration-300 text-center group"
                    >
                        <div className="w-16 h-16 bg-gradient-to-br from-green-100 to-green-200 rounded-full flex items-center justify-center text-green-600 mx-auto mb-5 text-2xl group-hover:scale-110 transition-transform duration-300">
                            <FaTicketAlt />
                        </div>
                        <h3 className="font-bold text-text-primary text-lg mb-3">My Tickets</h3>
                        <p className="text-sm text-text-muted leading-relaxed">Track the status of your support requests and view history.</p>
                        <button className="mt-4 text-green-600 text-sm font-semibold hover:text-green-700 transition-colors">
                            View Tickets →
                        </button>
                    </motion.div>
                    
                    <motion.div 
                        whileHover={{ y: -5 }}
                        className="bg-gradient-to-br from-white to-rose-50 p-8 rounded-3xl shadow-lg border border-glass-border hover:shadow-xl transition-all duration-300 text-center group"
                    >
                        <div className="w-16 h-16 bg-gradient-to-br from-rose-100 to-rose-200 rounded-full flex items-center justify-center text-primary-pink mx-auto mb-5 text-2xl group-hover:scale-110 transition-transform duration-300">
                            <FaComments />
                        </div>
                        <h3 className="font-bold text-text-primary text-lg mb-3">Live Chat</h3>
                        <p className="text-sm text-text-muted leading-relaxed">Chat with our support team in real-time for instant assistance.</p>
                        <button className="mt-4 text-primary-pink text-sm font-semibold hover:text-primary-pink transition-colors">
                            Start Chat →
                        </button>
                    </motion.div>
                </div> */}

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    {/* FAQs Section */}
                    <div className="lg:col-span-2">
                        <div className="bg-glass-card backdrop-blur-xl shadow-glass rounded-3xl border border-glass-border p-6 lg:p-8">
                            <h3 className="text-xl font-bold text-text-primary mb-6 flex items-center">
                                <div className="w-10 h-10 bg-gradient-to-r from-primary-pink to-[rgba(123,97,255,0.8)] rounded-full flex items-center justify-center mr-3">
                                    <FaQuestionCircle className="text-white" />
                                </div>
                                Frequently Asked Questions
                            </h3>

                            {/* Category Filter */}
                            <div className="flex flex-wrap gap-3 mb-8">
                                {categories.map(cat => (
                                    <button
                                        key={cat.id}
                                        onClick={() => setActiveCategory(cat.id)}
                                        className={`px-5 py-3 rounded-xl text-sm font-bold transition-all duration-300 flex items-center gap-2 ${activeCategory === cat.id 
                                            ? 'bg-primary-pink text-white shadow-[0_0_15px_rgba(255,46,136,0.4)]' 
                                            : 'bg-glass-card backdrop-blur-md border border-glass-border text-text-secondary hover:bg-[rgba(255,255,255,0.1)]'
                                        }`}
                                    >
                                        <span className="text-lg">{cat.icon}</span>
                                        {cat.label}
                                    </button>
                                ))}
                            </div>

                            <div className="space-y-4">
                                {filteredFaqs.length > 0 ? filteredFaqs.map((faq, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, y: 10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: index * 0.05 }}
                                        className="bg-glass-card backdrop-blur-md border border-glass-border rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
                                    >
                                        <button
                                            onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                            className="w-full flex justify-between items-center p-6 text-left font-bold text-text-secondary hover:bg-[rgba(255,255,255,0.05)] transition-colors group"
                                        >
                                            <span className="text-base lg:text-lg">{faq.q}</span>
                                            <div className={`p-2 rounded-full transition-all duration-300 ${openIndex === index 
                                                ? 'bg-gradient-to-r from-primary-pink to-[rgba(123,97,255,0.8)] text-white' 
                                                : 'bg-[rgba(255,255,255,0.05)] text-text-muted group-hover:bg-[rgba(255,255,255,0.08)]'
                                            }`}>
                                                {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                            </div>
                                        </button>
                                        {openIndex === index && (
                                            <motion.div
                                                initial={{ opacity: 0, height: 0 }}
                                                animate={{ opacity: 1, height: 'auto' }}
                                                exit={{ opacity: 0, height: 0 }}
                                                className="px-6 pb-6 bg-[rgba(255,255,255,0.02)] text-text-secondary leading-relaxed"
                                            >
                                                {faq.a}
                                            </motion.div>
                                        )}
                                    </motion.div>
                                )) : (
                                    <div className="text-center py-12">
                                        <div className="w-20 h-20 bg-gradient-to-r from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-full flex items-center justify-center mx-auto mb-4">
                                            <FaSearch className="text-text-muted text-2xl" />
                                        </div>
                                        <h4 className="text-lg font-semibold text-text-secondary mb-2">No results found</h4>
                                        <p className="text-text-muted max-w-md mx-auto">
                                            Try different keywords or browse through our categories to find what you're looking for.
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Contact Form Section */}
                    <div className="lg:col-span-1">
                        <div className="bg-glass-card backdrop-blur-xl border border-glass-border shadow-glass rounded-3xl shadow-xl border border-glass-border p-6 lg:p-8 sticky top-8">
                            {/* <h3 className="text-lg font-bold text-text-primary mb-6">Still need help?</h3> */}
                            {/* <form onSubmit={handleContactSubmit} className="space-y-6">
                                <div className="space-y-2">
                                    <label className="block text-sm font-semibold text-text-secondary">Subject</label>
                                    <CustomDropdown
                                        options={subjectOptions}
                                        value={contactForm.subject}
                                        onChange={(value) => setContactForm({...contactForm, subject: value})}
                                        placeholder="Select a subject"
                                        searchable={true}
                                    />
                                </div>
                                
                                <div className="space-y-2">
                                    <label className="block text-sm font-semibold text-text-secondary">Message</label>
                                    <textarea 
                                        rows="5" 
                                        placeholder="Describe your issue in detail..."
                                        value={contactForm.message}
                                        onChange={(e) => setContactForm({...contactForm, message: e.target.value})}
                                        className="w-full p-4 bg-[rgba(255,255,255,0.03)] border border-glass-border rounded-xl focus:ring-2 focus:ring-primary-pink focus:border-transparent outline-none text-sm transition-all duration-300 hover:border-glass-border"
                                    ></textarea>
                                </div>
                                
                                <motion.button 
                                    whileHover={{ scale: 1.02 }}
                                    whileTap={{ scale: 0.98 }}
                                    type="submit"
                                    className="w-full bg-gradient-to-r from-rose-600 to-pink-600 text-white py-4 rounded-xl font-bold hover:shadow-lg transition-all duration-300 shadow-md hover:shadow-rose-500/25"
                                >
                                    Submit Ticket
                                </motion.button>
                            </form> */}

                            <div className="mt-10 pt-8 border-t border-glass-border space-y-6">
                                <h4 className="font-bold text-text-primary text-sm uppercase tracking-wider">Contact Information</h4>
                                
                                <div className="flex items-center p-4 bg-[rgba(255,255,255,0.03)] rounded-2xl border border-glass-border">
                                    <div className="w-12 h-12 shrink-0 bg-gradient-to-br from-[rgba(255,255,255,0.1)] to-[rgba(255,255,255,0.05)] rounded-full flex items-center justify-center text-primary-pink mr-4">
                                        <FaPhoneAlt className="text-base" />
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        <p className="text-xs text-text-muted font-bold uppercase">Call Us</p>
                                        <p className="font-bold text-text-primary text-sm break-words">744-8539858</p>
                                        <p className="text-xs text-text-muted mt-1">Available 24/7</p>
                                    </div>
                                </div>
                                
                                <div className="flex items-center p-4 bg-[rgba(255,255,255,0.03)] rounded-2xl border border-glass-border">
                                    <div className="w-12 h-12 shrink-0 bg-gradient-to-br from-[rgba(255,46,136,0.2)] to-[rgba(255,46,136,0.1)] rounded-full flex items-center justify-center text-primary-pink mr-4">
                                        <FaEnvelope className="text-base" />
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        <p className="text-xs text-text-muted font-bold uppercase">Email Us</p>
                                        <p className="font-bold text-text-primary text-[12px] sm:text-sm lg:text-[12px] xl:text-[13px] 2xl:text-sm break-words">
                                            support@<wbr />kalyan<wbr />matrimony.com
                                        </p>
                                        <p className="text-xs text-text-muted mt-1">Response within 2 hours</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Help;